import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import OpenCloseIndicationContainer from "../../../OpenCloseIndication/components/OpenCloseIndication/OpenCloseIndicationContainer.js";
import OpeningSpecialHoursContainer from "./OpeningHoursSpecialContainer.js";
/* empty css                  */
const OpeningHours = ({
  className,
  labels,
  regular,
  openingHours,
  specialOpeningHours,
  special = [],
  isExpanded,
  onExpand,
  withTitle,
  announcement,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...rest,
    className: classnames(
      "location-opening-hours",
      { ["location-opening-hours--expanded"]: isExpanded },
      className
    )
  },
  withTitle && /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "location-opening-hours__heading" }, labels.title),
  announcement && /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, announcement),
  /* @__PURE__ */ React.createElement(
    OpenCloseIndicationContainer,
    {
      openingHours,
      specialOpeningHours,
      onExpand
    }
  ),
  /* @__PURE__ */ React.createElement("div", { className: "location-opening-hours__lists" }, special?.length ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(OpeningSpecialHoursContainer, { labels, special }), /* @__PURE__ */ React.createElement(
    Heading,
    {
      variant: "subheading2",
      component: "span",
      className: "location-opening-hours__list-heading"
    },
    labels.regularTitle
  )) : null, /* @__PURE__ */ React.createElement("dl", { className: "location-opening-hours__list" }, regular.map(({ label, today, status, entries }) => /* @__PURE__ */ React.createElement(React.Fragment, { key: label }, /* @__PURE__ */ React.createElement(
    "dt",
    {
      className: classnames("location-opening-hours__day", {
        "location-opening-hours__day--today": today
      })
    },
    label
  ), /* @__PURE__ */ React.createElement(
    "dd",
    {
      className: classnames("location-opening-hours__hours", {
        "location-opening-hours__hours--today": today,
        "location-opening-hours__hours--closed": status === "CLOSED"
      })
    },
    entries.map(({ key, value }) => /* @__PURE__ */ React.createElement("span", { key, className: "location-opening-hours__hours-entry" }, value))
  )))))
);
export {
  OpeningHours as default
};
//# sourceMappingURL=OpeningHours.js.map
